"use client";

import { ReactElement, useState } from "react";
import { styles } from "./HeadingPreview.style";
import { Icon, Icons } from "../../elements/Icon";
import { TitleWithListPopup } from "../../elements/TitleWithListPopup";

export interface HeadingPreviewProps {
  description: string | ReactElement;
  vinreg: string;
  vinregLabel: string;
  makeAndModel: string;
  vehicleLabel: string;
  riskBadgeText?: string;
  kilometersBadgeText?: string | ReactElement;
  riskPopupTitle?: string;
  riskPopupItems?: string[];
}

export const HeadingPreview = (props: HeadingPreviewProps) => {
  const {
    description,
    vinreg,
    vinregLabel,
    makeAndModel,
    vehicleLabel,
    riskBadgeText,
    kilometersBadgeText,
    riskPopupTitle,
    riskPopupItems,
  } = props;
  const hasBadges = riskBadgeText || kilometersBadgeText;
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const renderRiskButtonWithPopup = riskPopupTitle && !!riskPopupItems?.length;

  return (
    <div className={styles.root()}>
      <div className={styles.header()}>
        <Icon
          icon={Icons.checkMarkGreen}
          size={20}
          recolor="darkGreen"
          recolorTarget="circle"
          className={styles.iconWrapper()}
        />
        <h4 className={styles.headerText()}>{description}</h4>
      </div>
      <div className={styles.content()}>
        <div className={styles.infoGrid()}>
          <div className={styles.vinRegWrapper()}>
            <span className={styles.vinRegValue()}>
              {vinregLabel}: {vinreg}
            </span>
          </div>
          {makeAndModel && (
            <div className={styles.vehicleWrapper()}>
              <span className={styles.vehicleLabel()}>{vehicleLabel}:</span>
              <span className={styles.vehicleValue()}>{makeAndModel}</span>
            </div>
          )}
        </div>
        {hasBadges && (
          <div className={styles.badgesWrapper()}>
            {riskBadgeText && (
              <>
                {renderRiskButtonWithPopup ? (
                  <button
                    className={styles.riskBadgeButton()}
                    data-testid="risk-badge"
                    onClick={() => setIsPopupOpen(true)}
                  >
                    <span className={styles.riskBadge()}>
                      <span className={styles.badgeDot()} />
                      {riskBadgeText}
                    </span>
                    <span className={styles.infoIcon()}>
                      <Icon icon={Icons.infoBlack} recolor="stdTextGrey" />
                    </span>
                  </button>
                ) : (
                  <span className={styles.riskBadge()}>
                    <span className={styles.badgeDot()} />
                    {riskBadgeText}
                  </span>
                )}
              </>
            )}
            {kilometersBadgeText && (
              <div className={styles.kilometersBadge()} data-testid="kilometers-badge">
                {kilometersBadgeText}
              </div>
            )}
          </div>
        )}
      </div>
      {renderRiskButtonWithPopup && (
        <TitleWithListPopup
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          title={riskPopupTitle}
          items={riskPopupItems}
          testSelector="risks-info-modal"
          closeTestSelector="risks-info-modal-close"
        />
      )}
    </div>
  );
};
